/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Portal_Nav_BookingsInputs */

const en_booking_portal_nav_bookings = /** @type {(inputs: Booking_Portal_Nav_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar`)
};

const pl_booking_portal_nav_bookings = /** @type {(inputs: Booking_Portal_Nav_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalendarz`)
};

/**
* | output |
* | --- |
* | "Calendar" |
*
* @param {Booking_Portal_Nav_BookingsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_nav_bookings = /** @type {((inputs?: Booking_Portal_Nav_BookingsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Nav_BookingsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_nav_bookings(inputs)
	return en_booking_portal_nav_bookings(inputs)
});